<script>
    // @ is an alias to /src
    import { AppConfig } from '@/appConfig';
    export default {
        name: 'api-child-handler',
        created() {
            window.location = AppConfig.SERVER + '/' + this.$route.params.pathMatch
        },
    }
</script>
